import { defineComponent, reactive, watch, onMounted, toRefs, ref, computed, onBeforeUpdate, } from 'vue';
export default defineComponent({
    inheritAttrs: false,
    props: {
        modelValue: String,
        inputNumber: {
            type: Number,
            default: 6,
        },
        maxLength: {
            type: Number,
            default: 1,
        },
        type: {
            type: String,
            default: 'tel',
        },
        className: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    setup: (props, { emit, attrs }) => {
        const data = reactive({
            index: null,
            values: [],
        });
        const { inputNumber, modelValue } = toRefs(props);
        const input = ref([]);
        const firstInput = computed(() => input.value?.[0]);
        const lastInput = computed(() => input.value?.[inputNumber.value - 1]);
        const joinedValues = computed(() => data.values.join(''));
        const nextInput = computed(() => input.value?.[data.index + 1]);
        const previousInput = computed(() => input.value?.[data.index - 1]);
        const computedListeners = {
            ...attrs,
            blur: () => (data.index = null),
            change: () => emit('update:modelValue', joinedValues.value),
            focus: (event) => {
                data.index = [...input.value].indexOf(event.target);
            },
            input: (event) => {
                if (event.inputType === 'insertText') {
                    navigate(nextInput.value);
                }
                emit('update:modelValue', joinedValues.value);
            },
            keydown: (event) => {
                const cursorPosition = Number(event.target.dataset.index);
                const currentValue = data.values[cursorPosition];
                switch (event?.code) {
                    case 'ArrowDown':
                        navigate(lastInput.value);
                        break;
                    case 'ArrowLeft':
                        if (cursorPosition === 0 || !currentValue) {
                            navigate(previousInput.value);
                        }
                        break;
                    case 'ArrowRight':
                        if (cursorPosition === 1 || !currentValue) {
                            navigate(nextInput.value);
                        }
                        break;
                    case 'ArrowUp':
                        navigate(firstInput.value);
                        break;
                    case 'Backspace':
                        if (cursorPosition !== 0) {
                            data.values[cursorPosition] = '';
                            navigate(previousInput.value);
                        }
                        break;
                    default:
                        break;
                }
            },
            paste: (event) => {
                event.preventDefault();
                const pasteValue = event.clipboardData.getData('text/plain');
                const pasteValues = [];
                let newValues = [...data.values];
                for (let i = 0; i < inputNumber.value - data.index; i += 1) {
                    const char = pasteValue[i];
                    if (char) {
                        pasteValues.push(char);
                    }
                }
                newValues.splice(data.index, inputNumber.value - data.index + 1);
                newValues = newValues.concat(pasteValues);
                data.values = newValues;
                const lastIndex = newValues.length - 1;
                navigate(input.value[lastIndex]);
                emit('update:modelValue', joinedValues.value);
            },
        };
        watch(modelValue, (value) => {
            if (value !== joinedValues.value) {
                mapModelData();
            }
        });
        onBeforeUpdate(() => (input.value = []));
        onMounted(() => mapModelData());
        const mapModelData = () => (data.values = modelValue?.value?.toString().split(''));
        const navigate = (input) => {
            if (input) {
                input.focus();
                input.select();
            }
        };
        return {
            ...toRefs(data),
            input,
            computedListeners,
        };
    },
});
